// /pages/JoinProject.js
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { db, auth } from "../../config/firebaseConfig";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  arrayUnion,
  doc
} from "firebase/firestore";

const JoinProject = () => {
  const [inviteCode, setInviteCode] = useState("");
  const [message, setMessage] = useState("");
  const [autoJoining, setAutoJoining] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const codeFromURL = searchParams.get("code");
    if (codeFromURL) {
      setInviteCode(codeFromURL);
      setAutoJoining(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (autoJoining && inviteCode && auth.currentUser) {
      handleJoin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoJoining, inviteCode]);

  const handleJoin = async () => {
    try {
      if (!inviteCode) {
        setMessage("招待コードを入力してください。");
        return;
      }

      const q = query(
        collection(db, "projects"),
        where("inviteCode", "==", inviteCode)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setMessage("招待コードが無効です。");
        return;
      }

      const projectDoc = querySnapshot.docs[0];
      const projectRef = doc(db, "projects", projectDoc.id);
      const projectData = projectDoc.data();
      const uid = auth.currentUser.uid;

      if (projectData.members?.includes(uid)) {
        console.log(projectData.members)
        setMessage("すでにこのプロジェクトのメンバーです。");
        return;
      }

      // プロジェクトに追加
      await updateDoc(projectRef, {
        members: arrayUnion(uid),
      });

      // ユーザー側にも projectID を追加
      const userRef = doc(db, "users", uid);
      await updateDoc(userRef, {
        assignedProjects: arrayUnion(projectDoc.id),
      });

      // localStorage に保存
      localStorage.setItem("currentProjectID", projectDoc.id);
      localStorage.setItem("currentProjectName", projectData.name);

      setMessage(`✅ プロジェクト「${projectData.name}」に参加しました！`);
      setAutoJoining(false);
    } catch (error) {
      console.error("プロジェクト参加エラー:", error);
      setMessage("エラーが発生しました。もう一度お試しください。");
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h2>プロジェクトに参加する</h2>
      <input
        type="text"
        value={inviteCode}
        placeholder="招待コードを入力"
        onChange={(e) => setInviteCode(e.target.value)}
        style={{ marginRight: "0.5rem" }}
      />
      <button onClick={handleJoin}>参加</button>
      <p>{message}</p>
    </div>
  );
};

export default JoinProject;
